import { Header, Space, SubText, Toggle } from '@procurify/ui'
import styled from 'styled-components'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface IExternalPONumberingToggleCardProps {
  isEnabled: boolean
  onToggle: (value: boolean) => void
  isSaving: boolean
}

const HELP_CENTER_URL = 'https://success.procurify.com/en/articles/9001660'

// External help-article link inside the warning note. No DS component covers
// an external inline anchor — token-backed styled <a> (RFO twin).
const ExternalLinkStyled = styled.a`
  color: ${({ theme }) => theme.colors.text.link};
  text-decoration: none;
`

/**
 * Card CONTENT only (label, description, warning note with help-center link,
 * and the Toggle control) — the Card wrapper and its placement above the tabs
 * are Feature Set layout.
 */
export const ExternalPONumberingToggleCard = ({
  isEnabled,
  onToggle,
  isSaving,
}: IExternalPONumberingToggleCardProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='horizontal' justify='space-between' align='center'>
      <Space size='small'>
        <Header as='h5'>{intl.formatMessage(messages.toggleLabel)}</Header>
        <SubText>{intl.formatMessage(messages.toggleDescription)}</SubText>
        <SubText>
          {intl.formatMessage(messages.metaDescription)}{' '}
          <ExternalLinkStyled
            href={HELP_CENTER_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage(messages.metaLink)}
          </ExternalLinkStyled>
        </SubText>
      </Space>
      <Toggle
        checked={isEnabled}
        disabled={isSaving}
        onChange={() => onToggle(!isEnabled)}
        inputProps={{
          'aria-label': intl.formatMessage(messages.toggleAriaLabel),
        }}
      />
    </Space>
  )
}

ExternalPONumberingToggleCard.displayName = 'ExternalPONumberingToggleCard'
